(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rovia-inner-circle"]) return;
  try {
    
  (() => {
    const card = document.getElementById('RoviaCircle');
    if (!card) return;
    const key = 'rovia-circle-dismissed';
    let dismissed = false;
    try { dismissed = sessionStorage.getItem(key) === 'true'; } catch (_) {}
    const remember = () => { dismissed = true; try { sessionStorage.setItem(key, 'true'); } catch (_) {} };
    const show = () => {
      if (dismissed || document.activeElement?.matches('input,textarea,select') || document.querySelector('dialog[open]')) return;
      card.hidden = false;
    };
    const close = () => { card.hidden = true; remember(); };
    card.querySelector('.rovia-circle-close').addEventListener('click', close);
    card.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
    if (card.querySelector('[data-circle-success]')) { card.hidden = false; remember(); return; }
    if (card.querySelector('[data-circle-errors]')) { card.hidden = false; return; }
    if (card.dataset.home === 'true') {
      window.addEventListener('scroll', () => {
        if (window.scrollY > Math.max(300, window.innerHeight * 0.6)) show();
      }, { passive: true });
    } else { window.setTimeout(show, 3500); }
  })();

  } catch(e) { console.error(e); }
})();
})();
